module.exports = __webpack_public_path__ + "media/images/clearangel-1ce3c54eeafb86949ae11bb731f8cedd.png";